// @ts-strict-ignore
import React, { CSSProperties } from 'react'
import { Collapse, FormHelperText } from '@mui/material'
import { classList } from 'services/styles'
import useStyles from './styles'

export interface IInputGroupProps {
  label?: string
  error?: boolean
  name?: string
  helperText?: React.ReactNode
  children?: any
  style?: CSSProperties
}

function InputGroup(props: IInputGroupProps) {
  const { helperText, error, name, style } = props
  const hasHelperText = !!helperText
  const { classes } = useStyles()
  const dataCy = name ? `input-group-${name}` : 'input-group'

  return (
    <div data-cy={dataCy} style={style}>
      <div className={classList(classes.container, error && classes.error)}>
        {props.children}
      </div>

      <Collapse in={hasHelperText} mountOnEnter unmountOnExit>
        <FormHelperText error={error} variant="outlined" style={hasHelperText ? undefined : { marginTop: 0 }} data-cy={`${dataCy}-helper-text`}>
          {helperText || ''}{'\u00A0'}
        </FormHelperText>
      </Collapse>
    </div>
  )
}

export default React.memo(InputGroup)
